import dynamic from 'next/dynamic';
import A from './components/A';
import css from './index.module.scss';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function refurbished() {
    return (
        <div className={`refurbished ${css['refurbished']}`}>
            <A />
            <IndexDynamic />
            <style jsx global>
                {`
                    .ecoflow-header {
                        max-width: 100%;
                    }
                    .footer {
                        max-width: 100%;
                        overflow: hidden;
                    }
                `}
            </style>
        </div>
    );
}
